// extracted by mini-css-extract-plugin
export default {"con":"index_con__Vjf4D","tips":"index_tips__4gkUC"};